import { render, staticRenderFns } from "./items-list.vue?vue&type=template&id=179784e0&scoped=true&"
import script from "./items-list.vue?vue&type=script&lang=js&"
export * from "./items-list.vue?vue&type=script&lang=js&"
import style0 from "./items-list.vue?vue&type=style&index=0&id=179784e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179784e0",
  null
  
)

export default component.exports